
import * as React from 'react';
import { useDispatch } from 'react-redux';
import { setAuthResponse } from '../../store/auth';
import { useNavigate } from 'react-router-dom';
import { useAuth } from 'oidc-react';
import Logo from '../../components/Logo';
import { ProgressSpinner } from 'primereact/progressspinner';
import { authIsEnabled } from '../../utils/auth';

export default function AuthCallback() {
    const { userData } = authIsEnabled() ? useAuth() : {};
    const navigate = useNavigate();
    const dispatch = useDispatch();

    React.useEffect(() => {
        dispatch(setAuthResponse(userData));
        
        if (!!userData) {
            navigate('/');
        }
    }, [userData]);

    return (
        <div className="fixed inset-0 flex flex-col items-center justify-center text-white bg-allstate-navy">
            <div className="absolute top-6 left-4">
                <Logo className="text-white w-[100px]" />
            </div>

            <div className="flex flex-col gap-2 text-center">
                <ProgressSpinner className="w-8 h-8" strokeWidth="4" />
                <p>Signing you in<span className="absolute">...</span></p>
            </div>
        </div>
    );
}